import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { idFromObject } from '#src/gql/idFromObject.ts';
import { useQuery } from '#src/hooks/graphql/useQuery.ts';
import { joinFiltersWithOr } from '#src/lib/algolia.ts';

import type {
  FilterWatchlistQuery,
  FilterWatchlistQueryVariables,
} from './__generated__/useWatchlistFilterValue.graphql.ts';

const WATCHLIST_ALGOLIA_QUERY = gql`
  query FilterWatchlistQuery($id: ID!) {
    market {
      id
      watchlist(id: $id) {
        slug
        id
        title
        commonPlayers {
          nodes {
            id
            anyPlayer {
              slug
            }
          }
        }
      }
    }
  }
` as TypedDocumentNode<FilterWatchlistQuery, FilterWatchlistQueryVariables>;

type Props = {
  filterValue: string | undefined;
};

export const useWatchlistFilterValue = ({ filterValue }: Props) => {
  const { data, loading } = useQuery(WATCHLIST_ALGOLIA_QUERY, {
    variables: { id: idFromObject(filterValue ?? '') },
    skip: !filterValue,
  });
  const watchlist = data?.market?.watchlist;
  const playersSlugs = watchlist?.commonPlayers?.nodes?.map(
    player => player.anyPlayer?.slug
  );

  return {
    watchlistFilterValue: joinFiltersWithOr(
      (playersSlugs || [])?.map(slug => `player.slug:${slug}`)
    ),
    watchlistFilterTitle: watchlist?.title ?? '',
    loading: !!filterValue && loading && !data,
  };
};
